import { frontOfficeInstance } from '@/shared/api/api-instance';

export interface ExchangeResult {
  token: string;
  impersonationId: string;
  clientName: string;
  expiresAt: string;
  kind: 'support';
}

export async function exchangeCode(code: string): Promise<ExchangeResult> {
  const { data } = await frontOfficeInstance.post<ExchangeResult>(
    '/api/v1/auth/impersonation/exchange',
    { code },
  );
  return data;
}
